module.exports = "//d274d294w9cx2v.cloudfront.net/2f3b787e925e7300a6b671e44ac7299b8264b21f/images/photo-single.png";